import {SuiCheckboxModule, SuiDropdownModule, SuiPopupModule, SuiSelectModule} from '@angular-ex/semantic-ui';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';

import {ShortDescriptionPipe} from '../pipes/shortDescription.pipe';
import {I18nSelectPipe} from '../pipes/i18nSelect.pipe';
import {ArrayFieldComponent} from './array-field/array-field.component';
import {ArticleFilterComponent} from './article-filter/article-filter.component';
import {ArticlesListComponent} from './articles-list/articles-list.component';
import {ArticlesSortComponent} from './articles-sort/articles-sort.component';
import {InternalMessagesListComponent} from './internal-messages-list/internal-messages-list.component';

@NgModule({
  declarations: [
    ArticleFilterComponent,
    ArticlesListComponent,
    ArticlesSortComponent,
    InternalMessagesListComponent,
    ArrayFieldComponent,
  ],
  imports: [
    CommonModule,
    SuiCheckboxModule,
    SuiDropdownModule,
    FormsModule,
    SuiSelectModule,
    RouterLink,
    I18nSelectPipe,
    ShortDescriptionPipe,
    SuiPopupModule,
  ],
  providers: [],
  exports: [
    ArticleFilterComponent,
    ArticlesListComponent,
    ArticlesSortComponent,
    InternalMessagesListComponent,
    ArrayFieldComponent,
  ],
})
export class SharedComponentsModule {
}
